import React from 'react';
import Typography from '@mui/material/Typography';
import Title from './Title';

const Deposits = ({ orders }) => {
  const calculateTotalProfit = () => {
    const paidOrders = orders.filter((order) => order.status === 'Đã thanh toán');

    const totalProfit = paidOrders.reduce((accumulator, order) => {
      const profit = order.totalPrice * 0.08;
      return accumulator + profit;
    }, 0);

    return totalProfit;
  };

  const totalProfit = calculateTotalProfit();

  return (
    <React.Fragment>
      <Title>Tổng doanh thu</Title>
      <Typography component="p" variant="h4">
        {totalProfit.toLocaleString('en-US', { style: 'currency', currency: 'VND' })}
      </Typography>
    </React.Fragment>
  );
};

export default Deposits;
